/**
 * useFeatureFlag - single-flag derived hook
 *
 * Fail-safe: an unknown flag (not present in the resolve response) is treated
 * as DISABLED. Loading state is exposed so callers can avoid flicker.
 */
import { useFeatureFlags } from './useFeatureFlags';

export interface UseFeatureFlagResult {
  enabled: boolean;
  isLoading: boolean;
}

export function useFeatureFlag(key: string): UseFeatureFlagResult {
  const { data, isLoading } = useFeatureFlags();

  if (isLoading) {
    return { enabled: false, isLoading: true };
  }

  const match = data?.find((f) => f.key === key);
  return { enabled: match?.enabled ?? false, isLoading: false };
}
